import { Button } from '@design-system/button';
import { Icon } from '@design-system/icon';
import { Link } from '@design-system/link';
import { Typography } from '@design-system/typography';
import React, { FC } from 'react';

import { ProfileProps } from './models';

export const Profile: FC<ProfileProps & { isMobileView?: boolean }> = ({
  headline,
  greeting,
  icon: { icon },
  account,
  register,
  logIn,
  logOut,
  signedIn,
  handleSignOut,
  handleLogIn,
  handleRegister,
  userName,
  linkNavElement: LinkElement = Link,
  isMobileView,
}) => (
  <div className="cds-global-header-profile">
    {signedIn ? (
      <>
        <Typography
          className="cds-global-header-profile__greeting"
          variant="body"
          weight="medium"
          size="m"
          tag="p"
          content={`${greeting}${userName ?? ''} 👋`}
        />
        <LinkElement className="cds-global-header-profile__link" {...account} />
        <Button
          className="cds-global-header-profile__button cds-global-header-profile__button--log-out"
          {...logOut}
          variant={isMobileView ? 'primary' : 'secondary'}
          onClick={handleSignOut}
        />
      </>
    ) : (
      <>
        <div className="cds-global-header-profile__headline-wrapper">
          {isMobileView ? (
            <Icon
              className="cds-global-header-profile__headline-icon"
              icon={icon}
            />
          ) : null}
          <Typography
            className="cds-global-header-profile__headline"
            variant="body"
            weight="medium"
            size="m"
            tag="p"
            content={headline}
          />
        </div>
        <div className="cds-global-header-profile__buttons-wrapper">
          <Button
            className="cds-global-header-profile__button cds-global-header-profile__button--register"
            {...register}
            onClick={handleRegister}
          />
          <Button
            className="cds-global-header-profile__button cds-global-header-profile__button--log-in"
            {...logIn}
            onClick={handleLogIn}
          />
        </div>
      </>
    )}
  </div>
);
